/* eslint-disable react/prop-types */
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SaveIcon from "@mui/icons-material/Save";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Snackbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import theme from "assets/theme";
import dayjs from "dayjs";
import { useEffect, useMemo, useRef, useState } from "react";
import CustomFieldForm from "../../components/CustomFieldForm";
import { VisuallyHiddenInput } from "../../components/VisuallyHiddenInput";
import { LinkImage } from "../../utils";
import { API_URL, PaperComponent, API_ROUTES } from "../../utils/constants";
import { JsonTool } from "../../utils/jsonTools";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
const defaultValue = {
  ma: "",
  ten: "",
  diachi: "",
  anhdaidien: null,
  maquan: null,
  maphuong: null,
  donvi: null,
  ngaysinh: null,
  gioitinh: "M",
  chucvu: "",
  is_active: false,
  email: null,
};

const allowedFileTypes = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/svg+xml", // image/*
];

const FormThanhVien = ({
  data,
  open,
  onClose,
  onSubmit,
  title,
  validationErrors,
  action,
  dataHuyen,
  dataDonVi,
}) => {
  const axiosPrivateInstance = useAxiosPrivate();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const formRef = useRef(null);
  const inputFileRef = useRef(null);
  const [errors, setErrors] = useState();
  const [dataState, setDataState] = useState(defaultValue);
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });
  const [avatarUrl, setAvatarUrl] = useState("");
  const [fileAvatar, setFileAvatar] = useState();
  const [optionSubDitrict, setOptionSubDitrict] = useState([]);

  const handleChangeDistrict = (e) => {
    const value = e.target.value;
    setDataState((prev) => {
      return {
        ...prev,
        maquan: value,
        maphuong: "",
      };
    });
    getSubditrict(value);
  };
  const fieldInfor = useMemo(() => {
    let result = [
      {
        name: "Mã cán bộ",
        key: "ma",
        type: "text",
        required: true,
        maxLength: 255,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Họ Tên",
        key: "ten",
        type: "text",
        required: true,
        maxLength: 255,
        xs: 12,
        md: 8,
        lg: 8,
      },
      {
        name: "Chức vụ",
        key: "chucvu",
        type: "text",
        maxLength: 255,
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Địa chỉ",
        key: "diachi",
        type: "text",
        maxLength: 255,
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Quận huyện",
        key: "maquan",
        type: "select",
        onChange: handleChangeDistrict,
        unicode: "ma",
        required: true,
        hasPlaceholder: true,
        labelKeyOption: "ten",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Phường/Xã",
        key: "maphuong",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "ma",
        labelKeyOption: "ten",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Email",
        key: "email",
        required: true,
        type: "text",
        maxLength: 255,
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Ngày sinh",
        key: "ngaysinh",
        type: "date",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Giới tính",
        key: "gioitinh",
        type: "select",
        unicode: "id",
        required: true,
        hasPlaceholder: true,
        labelKeyOption: "ten",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Đơn vị",
        key: "donvi",
        type: "select",
        unicode: "id",
        required: true,
        hasPlaceholder: true,
        labelKeyOption: "ten",
        xs: 12,
        md: 8,
        lg: 8,
      },
    ];
    return result;
  }, []);
  const getSubditrict = (code) => {
    axiosPrivateInstance
      .get(API_ROUTES.GETXA, { params: { huyen: code } })
      .then((res) => {
        setOptionSubDitrict(res?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    setFileAvatar(null);
    if (data?.id) {
      setDataState(data);
      setAvatarUrl(data?.anhdaidien);
      getSubditrict(data?.maquan);
    } else {
      setAvatarUrl(null);
      setDataState(defaultValue);
    }
  }, [data]);

  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...dataState };
    if (action == "Edit") {
      _data["id"] = data?.id;
      _data["rowIndex"] = data?.rowIndex;
      _data["username"] = data?.ma;
    }
    const listFormatDate = ["ngaysinh"];
    listFormatDate?.forEach((field) => {
      _data[field] =
        dataState?.[field] &&
        !errors?.[field] &&
        dayjs(dataState?.[field])?.isValid()
          ? dayjs(dataState?.[field]).format("YYYY-MM-DD")
          : null;
    });

    if (fileAvatar && fileAvatar.name) {
      let json = await JsonTool.convertToBase64(fileAvatar);
      _data["anhdaidien"] = json;
      _data["tenanhdaidien"] = fileAvatar.name;
      if (action == "Edit") {
        _data["edit"] = true;
      }
    } else {
      if (action == "Edit") {
        _data["edit"] = false;
      }
    }
    const newValidationErrors = validateOBJ(_data);
    let _tempValid = newValidationErrors;

    if (Object.values(_tempValid).some((error) => error)) {
      setErrors((prev) => ({
        ...prev,
        ...newValidationErrors,
      }));
      return;
    }
    if (!fileAvatar?.name && action == "Edit") {
      delete _data["anhdaidien"];
    }

    onSubmit(_data);
  }

  const handelClear = () => {
    onClose();
  };
  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  useEffect(() => {
    if (open) {
      setErrors({});
    }
  }, [open]);

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };

  const handleChangeDataState = (data) => {
    let { name, value } = data;
    setDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleErrorDataState = (error) => {
    let { name, value } = error;
    setErrors((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleFileChange = (event) => {
    if (errors && errors.anhdaidien) {
      setErrors({ ...errors, anhdaidien: "" });
      avatarUrl && setAvatarUrl(null);
      fileAvatar && fileAvatar.name && setFileAvatar(null);
    }
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (selectedFile.size / (1024 * 1024) > 10) {
        let _err = "Kích thước tệp quá lớn. Tệp upload phải nhỏ hơn 10MB.";
        setErrors({ ...errors, anhdaidien: _err });
        return;
      }
      // Kiểm tra định dạng
      const fileTypeIsValid = allowedFileTypes.some(
        (type) => selectedFile.type == type
      );

      if (!fileTypeIsValid) {
        let _err = "Tệp phải có định dạng: .jpeg, .png, .svg, .gif";
        setErrors({ ...errors, anhdaidien: _err });
        return; // Dừng xử lý nếu định dạng không hợp lệ
      }
      const urlIamge = URL.createObjectURL(selectedFile);
      setAvatarUrl(urlIamge);
      setFileAvatar(selectedFile);
    }
  };
  return (
    <>
      {alert.alert && (
        <Snackbar
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={alert.alert}
          onClose={handleCloseAlert}
        >
          <Alert onClose={handleCloseAlert} severity={alert.type}>
            {alert.message}
          </Alert>
        </Snackbar>
      )}
      <Dialog
        fullScreen={fullScreen}
        open={open}
        PaperComponent={PaperComponent}
        onClose={handelClear}
        scroll="paper"
        PaperProps={{
          sx: {
            "@media (min-width: 768px)": {
              minWidth: "40rem",
            },
            height: "100%",
          },
        }}
      >
        {/* Form*/}
        <form
          ref={formRef}
          method="post"
          encType="multipart/form-data"
          style={{
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            height: "100%",
          }}
        >
          {/* Tiêu đề modal - tham số title */}
          <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
            {title ? title : "Chỉnh sửa thành viên hội đồng"}
            <IconButton
              aria-label="close"
              onClick={handelClear}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers sx={{ overflow: "auto", paddingTop: "0" }}>
            <Box>
              {/* show lỗi từ khi không xác định được từ các field ở form */}
              {errors && errors.error ? (
                <Grid container sx={{ textAlign: "center", mb: 0 }}>
                  <Grid item xs={12}>
                    <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                      {errors.error}
                    </Alert>
                  </Grid>
                </Grid>
              ) : (
                ""
              )}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  padding: "0.5rem 0",
                  gap: "0.5rem",
                }}
              >
                <img
                  src={avatarUrl ? API_URL + avatarUrl : LinkImage.userDefault}
                  alt="Avatar"
                  style={{
                    verticalAlign: "middle",
                    width: "150px",
                    height: "150px",
                    borderRadius: "50%",
                    backgroundColor: "#d6d6d6",
                  }}
                />
                <Button
                  component="label"
                  variant="contained"
                  tabIndex={-1}
                  startIcon={<CloudUploadIcon />}
                  sx={{ color: "#ffffff" }}
                >
                  Thêm ảnh
                  <VisuallyHiddenInput
                    type="file"
                    onChange={(e) => handleFileChange(e)}
                    accept="image/*"
                    ref={inputFileRef}
                  />
                </Button>
                {errors && errors.anhdaidien && (
                  <Typography sx={{ color: "red", fontSize: "0.75rem" }}>
                    {errors.anhdaidien}
                  </Typography>
                )}
              </Box>

              {fieldInfor?.length > 0 && (
                <CustomFieldForm
                  key={"fieldInfor"}
                  listField={fieldInfor}
                  data={dataState}
                  onChange={handleChangeDataState}
                  onError={handleErrorDataState}
                  errorValues={errors}
                  listOptionDic={{
                    maquan: dataHuyen,
                    maphuong: optionSubDitrict,
                    donvi: dataDonVi,
                    gioitinh: [
                      {
                        id: "M",
                        ten: "Nam",
                      },
                      {
                        id: "F",
                        ten: "Nữ",
                      },
                      {
                        id: "O",
                        ten: "Khác",
                      },
                    ],
                  }}
                />
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handelClear}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <Button
              type="submit"
              variant="contained"
              startIcon={<SaveIcon />}
              size="small"
              onClick={onSubmitForm}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Lưu
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};
const validMail = (value, name) => {
  let result = false;
  if (value && JsonTool.validateEmail(value)) {
    result = true;
  }
  return result;
};
const validateRequired = (value) => {
  let result = !!value?.length;
  if (typeof value == "number") {
    result = true;
  }
  return result;
};
function validateOBJ(tv) {
  let result = {
    ma: !validateRequired(tv.ma) ? "Mã cán bộ không được trống" : "",
    ten: !validateRequired(tv.ten) ? "Họ tên không được trống" : "",
    maquan: !validateRequired(tv.maquan) ? "Chọn quận huyện" : "",
    maphuong: !validateRequired(tv.maphuong) ? "Chọn phường xã" : "",
    donvi: !validateRequired(tv.donvi) ? "Chọn đơn vị" : "",
    gioitinh: !validateRequired(tv.gioitinh) ? "Chọn giới tính" : "",
    // anhdaidien: !validateRequired(tv.anhdaidien) ? "Chọn ảnh đại diện" : "",
    email: !validateRequired(tv.email)
      ? "Email không được trống"
      : validMail(tv.email)
      ? "Định dạng Email không đúng"
      : "",
  };
  return result;
}
export default FormThanhVien;
